import { createContext } from 'react';

import { TableDirection } from '../../types';

export const TableContext = createContext<TableDirection>(TableDirection.Auto);
